"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCloseButton = exports.StyledChip = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("../../shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledChip = _styledComponents.default.button.withConfig({
  displayName: "Chipstyles__StyledChip",
  componentId: "sc-1u88j0g-0"
})(["", ";background:", ";color:", ";padding:8px 16px;border-radius:20px;white-space:nowrap;border:1px solid transparent;outline:none;cursor:pointer;display:inline-flex;justify-content:center;align-items:center;margin-right:8px;:hover{background:", ";}:focus{border:1px solid ", ";}:active{border:1px solid transparent;background:", ";color:white;svg{path{fill:white;}}}", ""], _shared.theme.typography.h6.css, `${_shared.theme.palette.brand.primary.gray}10`, _shared.theme.palette.brand.primary.charcoal, `${_shared.theme.palette.brand.primary.gray}30`, _shared.theme.palette.ui.cta.yellow, _shared.theme.palette.ui.neutral.grey1, ({
  disabled
}) => disabled && (0, _styledComponents.css)(["pointer-events:none;color:#6e6e6e;background-color:", ";"], _shared.theme.palette.ui.neutral.grey5));

exports.StyledChip = StyledChip;

const StyledCloseButton = _styledComponents.default.span.withConfig({
  displayName: "Chipstyles__StyledCloseButton",
  componentId: "sc-1u88j0g-1"
})(["margin-left:10px;svg{", ";}"], ({
  disabled
}) => disabled && `fill: #6E6E6E;`);

exports.StyledCloseButton = StyledCloseButton;